// extracted by mini-css-extract-plugin
export var fullHeightState = "_b-7";
export var headerCell = "_b-1";
export var loadingStateCell = "_b-4";
export var rowWrapper = "_b-3";
export var standaloneTable = "_b-8";
export var standaloneTableWithBodyFill = "_b-9";
export var stateCell = "_b-5";
export var table = "_b-0";
export var tableBodyFiller = "_b-6";
export var white = "_b-2";